import { render } from "./ProfileVisitors.vue?vue&type=template&id=07251dd8"
import script from "./ProfileVisitors.vue?vue&type=script&lang=js"
export * from "./ProfileVisitors.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MY PROJECTS\\Vue 3 Project\\MarriageBeauroWeb\\marriage_beauro_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__